
import "./App.css";

import PageSkills from "./pages/Skills";
import PageProjects from "./pages/Projects";
import PageAbout from "./pages/About";
import PageLeisure from "./pages/Leisure";
import { BrowserRouter, Route, Routes } from "react-router-dom"
import Homepage from "./pages/Homepage";
import { WebFooter } from "./components/WebFooter";
import NavBar from "./components/NavBar";

function App() {
  return (
      <BrowserRouter>
        <NavBar></NavBar>
        <Routes>
          <Route path="/" element={<Homepage></Homepage>}></Route>
          <Route path="/about" element={<PageAbout></PageAbout>}></Route>
          <Route path="/skills" element={<PageSkills></PageSkills>}></Route>
          <Route path="/projects" element={<PageProjects></PageProjects>}></Route>
          <Route path="/leisure" element={<PageLeisure></PageLeisure>}></Route>
        </Routes>
        <WebFooter></WebFooter>
      </BrowserRouter>
  );
}

export default App;
